import React, { useEffect, useState } from 'react';
import { supabase } from '../../utils/supabaseClient';

function Contact() {
  const [name, setName] = useState('');

  useEffect(() => {
    const fetchUserAndProfile = async () => {
      const { data: { user }, error: userError } = await supabase.auth.getUser();

      if (userError || !user) return;

      const { data: profile } = await supabase
        .from('accounts')
        .select('name')
        .eq('id', user.id)
        .maybeSingle();

      if (profile && profile.name) {
        setName(profile.name);
      }
    };

    fetchUserAndProfile();
  }, []);

  return (
    <section className='welcome-page contain align-middle'>
      <h1>
        Hello, {name || 'friend'}! 
      </h1>
      <p>
        For help, questions, concerns or feedback, please email carina@mglagency.com
      </p>
    </section>
  );
}

export default Contact;
